export enum DeclineReason {
    CANNOT_EXAMINE_PHYSICAL_DOCUMENT = 'CANNOT_EXAMINE_PHYSICAL_DOCUMENT',
    ILLEGAL_DOCUMENT = 'ILLEGAL_DOCUMENT',
    INVALID_DOCUMENT = 'INVALID_DOCUMENT',
    INCORRECT_INFORMATION = 'INCORRECT_INFORMATION',
    NOT_COMFORTABLE_SIGNING = 'NOT_COMFORTABLE_SIGNING',
    ILLEGAL_AUTHORIZED_REPRESENTATIVE = 'ILLEGAL_AUTHORIZED_REPRESENTATIVE',
    OTHER = 'OTHER'
}

/***
 * authorized-representative-controller
 * post /external/representative/decline
 * Decline to sign the i9 form
 */
export interface RepresentativeDeclineRequest {
    declineReasonText: string;
    section3DeclineReason: DeclineReason;
}



// WEBPACK FOOTER //
// ./src/dtos/remote-i9-decline.ts